// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#rolesRow {

    color: black;
}
.table th{
    cursor: pointer;
    text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/app/team-roles/team-roles.component.css"],"names":[],"mappings":"AAAA;;IAEI,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":["#rolesRow {\n\n    color: black;\n}\n.table th{\n    cursor: pointer;\n    text-align: left;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
